module.exports = "/static/assets/5c6ee7ea907b1335ebf5b032296efd54.png";